import { Fade, ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import EditIcon from "@mui/icons-material/Edit";
import React, { useState } from "react";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

function WinWireReplyOptions({ handleEditClick, handleDeleteClick, isOwner }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    event.stopPropagation();
    event.preventDefault();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (event) => {
    event.stopPropagation();
    event.preventDefault();
    setAnchorEl(null);
  };

  const handleMenuItemClick = (event, handler) => {
    handleClose(event);
    if (typeof handler === "function") {
      handler();
    }
  };

  const menuItems = [
    {
      label: "Edit Message",
      onClick: (event) => {
        handleMenuItemClick(event, handleEditClick);
      },
      icon: <EditIcon />,
      disabled: !isOwner,
    },
    {
      label: "Delete Message",
      onClick: (event) => {
        handleMenuItemClick(event, handleDeleteClick);
      },
      color: "red",
      icon: <DeleteOutlineIcon />,
      disabled: !isOwner,
    },
  ];

  return (
    <>
      <MoreVertIcon onClick={handleClick} />
      <Menu
        open={open}
        onClose={handleClose}
        anchorEl={anchorEl}
        keepMounted
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        TransitionComponent={Fade}
        sx={{
          "& .MuiPaper-root": {
            backgroundColor: "#28282A !important",
            color: "#ddd9d5",
            p: 1,
            borderRadius: 1,
          },
        }}
      >
        {menuItems.map((menuItem) => (
          <MenuItem
            key={menuItem.label}
            onClick={menuItem.onClick}
            disabled={menuItem.disabled}
            sx={{
              "&:hover": { backgroundColor: "#444" },
            }}
          >
            <ListItemIcon sx={{ color: menuItem.color || "#ddd9d5", fontSize: "1rem" }}>
              {menuItem.icon}
            </ListItemIcon>
            <ListItemText
              sx={{
                "& .MuiTypography-root ": {
                  fontSize: "0.9rem",
                  color: menuItem.color || "#ddd9d5",
                },
              }}
            >
              {menuItem.label}
            </ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}

export default WinWireReplyOptions;
